module.exports = "/images/vendor/flag-icon-css/flags/1x1/hk.svg?4a0f09ba94fb32cb4ef1c2c51df0441c";